<template>
  <b-row>
    <b-col cosl="12">
      <b-table
        id="reports-table"
        responsive="sm"
        hover
        :items="reports"
        :fields="fields"
        stacked="md"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        sort-icon-left
        :busy="isLoading"
        :perPage="perPage"
        :currentPage="currentPage"
        show-empty
        empty-text="Trenutno nema izveštaja."
      >
        <template v-slot:cell(title)="row">
          <a href="#" @click.prevent="row.toggleDetails">{{ row.item.title }}</a>
        </template>
        <template v-slot:cell(type)="{ item }">{{ reportType[item.type] }}</template>
        <template v-slot:cell(status)="{ item }">
          <b-badge :variant="showStatus(item.status).variant">{{ showStatus(item.status).response }}</b-badge>
        </template>

        <template v-slot:table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner small class="align-middle mr-2"></b-spinner>
            <strong>Učitavanje...</strong>
          </div>
        </template>

        <template v-slot:cell(actions)="row">
          <b-button
            v-if="row.detailsShowing"
            size="sm"
            @click="row.toggleDetails"
            variant="primary"
          >
            <i class="fas fa-eye-slash"></i>
            Zatvori detalje
          </b-button>
          <b-button v-else size="sm" @click="row.toggleDetails" variant="outline-primary">
            <i class="fas fa-eye"></i>
            Prikaži detalje
          </b-button>
        </template>

        <template v-slot:empty="scope">
          <b-alert variant="warning" show>{{ scope.emptyText }}</b-alert>
        </template>
        <template v-slot:row-details="{ item }">
          <b-card>
            <b-form-group
              label="Dokument"
              label-cols-lg="3"
              label-cols-xl="2"
              label-align-lg="right"
            >
              <b-button @click.prevent="download(item)" variant="link">
                <b-icon icon="download" class="mr-1"></b-icon>
                {{ item.filename }}
              </b-button>
            </b-form-group>
            <b-form-group
              label="Napomena"
              label-cols-lg="3"
              label-cols-xl="2"
              label-align-lg="right"
            >
              <div style="padding:0.5rem" v-html="item.notes"></div>
            </b-form-group>
            <b-form-group label="Akcije" label-cols-lg="3" label-cols-xl="2" label-align-lg="right">
              <b-button variant="danger" size="sm" @click.prevent="deleteReport(item)">
                <b-icon icon="trash" class="mr-1"></b-icon>Obriši
              </b-button>
            </b-form-group>
          </b-card>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        first-number
        last-number
        align="center"
        aria-controls="projects-table"
      ></b-pagination>
    </b-col>
  </b-row>
</template>

<script>
import config from "@/config";
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      URL: config.API_URL,
      sortBy: "created_at",
      stackedBr: "md",
      sortDesc: true,
      isLoading: true,
      currentPage: 1,
      perPage: 20,
      fields: [
        { key: "title", label: "Naziv", sortable: true },
        { key: "type", label: "Vrsta", sortable: false },
        { key: "status", label: "Status", sortable: false },
        {
          key: "created_at",
          label: "Datum",
          sortable: true,
          thStyle: { width: "190px" }
        },
        { key: "actions", label: "Detalji", thStyle: { width: "160px" } }
      ],
      reportType: config.report_type,
      reportStatus: config.report_status,
      statusColor: config.report_status_color
    };
  },
  computed: {
    ...mapGetters({
      reports: "report/allReports",
      rows: "report/countReports"
    })
  },
  created() {
    this.getReports()
      .then()
      .catch(err => {
        console.log(err);
      })
      .then(() => {
        this.isLoading = false;
      });
  },
  methods: {
    ...mapActions({
      downloadReport: "report/download",
      getReports: "report/fetchAllReports",
      destroy: "report/destroyReport"
    }),
    download(report) {
      this.downloadReport(report)
        .then()
        .catch(err => {
          this.makeToast(
            "danger",
            "Greška",
            "Dokument " + report.filename + " nije pronađen!"
          );
        });
    },
    deleteReport(report) {
      var response = confirm("Da li želite da obrišete ovaj izveštaj?");
      if (response) {
        this.destroy(report.id)
          .then(() => {
            this.makeToast(
              "success",
              "Izveštaj obrisan!",
              "Izveštaj " + report.title + " je obrisan."
            );
          })
          .catch(err => {
            this.makeToast("danger", "Greška!", "Grška prilikom brisanja.");
          });
      }
    }
  }
};
</script>

<style>
</style>
